import IcoMoon from '@/components/IcoMoon'
import AccordionSidebar from '@/widgets/v2/AI/Sidebar/AccordianSidebar'
import * as style from './style'

interface Props {
  isOpen: boolean
  toggleSidebar: () => void
}

const Sidebar = ({ isOpen, toggleSidebar }: Props): JSX.Element => {
  return (
    <div>
      {/* Background Overlay */}
      {isOpen && <div className="fixed inset-0 z-[3] transition-opacity duration-300 bg-black bg-opacity-20"></div>}

      {/* Sidebar */}
      <div
        className={`fixed ${
          style.sidebarContainer
        } right-0 h-[100vh] bg-white shadow-lg z-[4] transition-transform duration-300 ease-in-out
          ${isOpen ? 'translate-x-0' : 'translate-x-full'}
          w-full lg:w-[580px] xxl:w-[600px] xxxl:w-[660px] p-4 sm:p-[38px] lg:py-0 lg:px-[38px]`}
      >
        {isOpen && (
          <button
            onClick={toggleSidebar}
            className={`absolute hidden lg:flex items-center px-4 h-12 py-2 transform -translate-y-1/2 bg-primary rounded-tl-[23px] rounded-bl-[23px] shadow-md top-10 -left-12`}
          >
            <IcoMoon icon="chevron-right" color="white" size={16} />
          </button>
        )}
        <AccordionSidebar toggleResources={toggleSidebar} isResourceOpen={isOpen} />
      </div>
    </div>
  )
}

export default Sidebar
